import React from "react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/918007138807?text=Hi%20I%20would%20like%20to%20know%20more%20about%20your%20services"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px", // distance from bottom
        right: "20px", // distance from right
        zIndex: 1000, // keep it above everything
      }}
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/2044px-WhatsApp.svg.png"
        alt="WhatsApp"
        style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          transition: "transform 0.3s ease",
        }}
        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
      />
    </a>
  );
};

export default WhatsAppButton;
